/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { refundOrderControllerCreate } from '../fn/refund-order/refund-order-controller-create';
import { RefundOrderControllerCreate$Params } from '../fn/refund-order/refund-order-controller-create';
import { refundOrderControllerFindAll } from '../fn/refund-order/refund-order-controller-find-all';
import { RefundOrderControllerFindAll$Params } from '../fn/refund-order/refund-order-controller-find-all';
import { refundOrderControllerFindOne } from '../fn/refund-order/refund-order-controller-find-one';
import { RefundOrderControllerFindOne$Params } from '../fn/refund-order/refund-order-controller-find-one';

@Injectable({ providedIn: 'root' })
export class RefundOrderService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `refundOrderControllerFindAll()` */
  static readonly RefundOrderControllerFindAllPath = '/api/refund-order';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `refundOrderControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  refundOrderControllerFindAll$Response(params?: RefundOrderControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return refundOrderControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `refundOrderControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  refundOrderControllerFindAll(params?: RefundOrderControllerFindAll$Params, context?: HttpContext): Observable<void> {
    return this.refundOrderControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `refundOrderControllerCreate()` */
  static readonly RefundOrderControllerCreatePath = '/api/refund-order';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `refundOrderControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  refundOrderControllerCreate$Response(params: RefundOrderControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return refundOrderControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `refundOrderControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  refundOrderControllerCreate(params: RefundOrderControllerCreate$Params, context?: HttpContext): Observable<void> {
    return this.refundOrderControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `refundOrderControllerFindOne()` */
  static readonly RefundOrderControllerFindOnePath = '/api/refund-order/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `refundOrderControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  refundOrderControllerFindOne$Response(params: RefundOrderControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return refundOrderControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `refundOrderControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  refundOrderControllerFindOne(params: RefundOrderControllerFindOne$Params, context?: HttpContext): Observable<void> {
    return this.refundOrderControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
